/*
  Sticky mobile add-to-cart bar for the Static PDP template.
  It does not add to cart itself — it just smooth-scrolls the page back up
  to the real add-to-cart button/form, which stays the single source of
  truth for the actual add-to-cart request (product-form.js + cart-drawer).
*/
document.addEventListener('DOMContentLoaded', () => {
  const bar = document.querySelector('[data-spdp-sticky-atc]');
  if (!bar) return;

  const anchor = document.querySelector('[data-spdp-atc-anchor]');
  const scrollButton = bar.querySelector('[data-spdp-sticky-scroll]');

  if (!anchor || !scrollButton) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    },
    { threshold: 0 }
  );
  observer.observe(anchor);

  scrollButton.addEventListener('click', () => {
    anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
});
